import { ICON_TYPES } from '../constants';

export const WifiIcon = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75001 16.625C8.75001 15.6625 9.53751 14.875 10.5 14.875C11.4625 14.875 12.25 15.6625 12.25 16.625C12.25 17.5875 11.4625 18.375 10.5 18.375C9.53751 18.375 8.75001 17.5875 8.75001 16.625ZM16.065 11.06C12.9938 7.98875 7.99751 7.98875 4.92626 11.06L6.16001 12.2937C8.54876 9.905 12.4338 9.905 14.8225 12.2937L16.0563 11.06H16.065ZM20.3963 6.72875C17.7538 4.08625 14.2363 2.625 10.5 2.625C6.76376 2.625 3.24626 4.0775 0.60376 6.72875L1.83751 7.9625C4.14751 5.6525 7.22751 4.375 10.5 4.375C13.7725 4.375 16.8438 5.6525 19.1625 7.9625L20.3963 6.72875Z"
        fill="#43494F"
      />
    </svg>
  );
};

WifiIcon.iconType = ICON_TYPES.WIFI;
